import { Link } from "react-router-dom";
import { site } from "@/config/site";

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="footer-inner footer-grid">
        <div>
          <p className="footer-identity">
            {site.name}
            <br />
            {site.location}
          </p>
          <p>
            Technologist and computational social scientist. The early work
            was product lines: how an idea becomes a system a business can
            run. The question then became why people act, and how they meet
            the systems around them. ecosystem.Ai scores the next action
            while the person is still acting, and the response updates the
            score that follows. EcosystemCode turns a validated design into
            a working system — UI, API, and database, deterministic and
            reproducible — and adds AI only where you turn it on.
          </p>
        </div>
        <div>
          <p className="section-kicker">On this site</p>
          <p>
            <Link to="/building">Building</Link>
            <br />
            <Link to="/now">Now</Link>
            <br />
            <Link to="/teaching">Teaching</Link>
            <br />
            <Link to="/talks">Talks</Link>
            <br />
            <Link to="/contact">Contact</Link>
          </p>
        </div>
        <div>
          <p className="section-kicker">Elsewhere</p>
          <p>
            <a href={site.profiles.ecosystem}>ecosystem.Ai</a>
            <br />
            <a href={site.profiles.ecosystemCode}>EcosystemCode</a>
            <br />
            <a href={site.profiles.githubOrg}>GitHub / ecogenetic</a>
            <br />
            <a href={site.profiles.linkedin}>LinkedIn</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
